import axios from "axios";
const config = {
  headers: {
    Authorization: "",
  },
};

const ServerCall = {
  post: async (route, data, token) => {
    try {

      config.headers.Authorization =  "Bearer " + token;
      const result = await axios.post(
        "https://www.netuno.net.ve/api/portal/web/exp/v1" + route,
        data,
        config
      );

      return result.data;
    } catch (error) {

      throw error;
    }
  },
  postNetUno: async (route, data) => {
    try {

      config.headers.Authorization = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJKV1QgQnVpbGRlciBNQ29uc3VsdGluZyBOZXRVbm8iLCJpYXQiOjE2NzU0Mjc4NjQsImV4cCI6MTcwNjk2Mzg2NCwiYXVkIjoid3d3Lm5ldHVuby5uZXQiLCJzdWIiOiJob2xhQG1hY2FyZW5hLmFpIiwiUm9sZSI6WyJBZG1pbiIsIkFkbWluIl0sImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL25hbWUiOiJFbnYgVUFUIn0.XGJitFfrVUcNhM8IKBc5pOkwgVe20TEhFXxEgggXMQdQ2ATvqg-rojZZJkR91NImhWYFgSorQTIG_h0YC5-U7g";
      const result = await axios.post(
        "https://www.netuno.net.ve/NetUnoDes/api/v1" + route,
        data,
        config
      );

      return result.data;
    } catch (error) {

      throw error;
    }
  },
};
export default ServerCall;